import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

export interface ShipToConfirmationDetails {
  message?: string;
  currentShipToName?: string;
  branchName?: string;
}

interface ShipToConfirmationDialogProps {
  open: boolean;
  details: ShipToConfirmationDetails | null;
  isSubmitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ShipToConfirmationDialog: React.FC<ShipToConfirmationDialogProps> = ({
  open,
  details,
  isSubmitting,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogContent sx={{ p: 4 }}>
        {details?.currentShipToName ? (
          <>
            <Typography sx={{ mb: 1, fontSize: "1.05rem", lineHeight: 1.6 }}>
              Your selected ship-to{" "}
              <Typography component="span" fontWeight={700}>
                {details.currentShipToName}
              </Typography>{" "}
              is not available
              {details.branchName && (
                <>
                  {" "}
                  for{" "}
                  <Typography component="span" fontWeight={700}>
                    {details.branchName}
                  </Typography>
                </>
              )}
              .
            </Typography>
            <Typography sx={{ mb: 3, fontSize: "1.05rem", lineHeight: 1.6 }}>
              Would you like to continue? If you proceed, the ship-to will be
              changed to the default ship-to for this branch.
            </Typography>
          </>
        ) : (
          <Typography sx={{ mb: 3, fontSize: "1.05rem", lineHeight: 1.6 }}>
            {details?.message}
          </Typography>
        )}
        <Grid container spacing={2} justifyContent="flex-end">
          <Grid item>
            <Button
              className="blueButtonOutline"
              onClick={onCancel}
              disabled={isSubmitting}
            >
              No
            </Button>
          </Grid>
          <Grid item>
            <Button
              className="blueButtonSolid"
              onClick={onConfirm}
              disabled={isSubmitting}
            >
              Yes
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ShipToConfirmationDialog;
